import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { Flex, SearchInput } from '@optiaxiom/react';
import { useDecision } from '@optimizely/react-sdk';

import { AgentStatus, AgentType } from '../../../hooks/useAgentsUrlParams';
import { AgentAddDropdown } from '../AddAgentDropdown';
import { AgentFilters } from '../AgentFilters';

import { styles } from './AgentSearchInput.css';

type AgentSearchInputProps = {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  agentType?: AgentType;
  status?: AgentStatus;
  onAgentTypeChange: (type?: AgentType) => void;
  onStatusChange: (status?: AgentStatus) => void;
};

export function AgentSearchInput({
  searchQuery,
  onSearchChange,
  agentType,
  status,
  onAgentTypeChange,
  onStatusChange,
}: AgentSearchInputProps) {
  const [workflowAgentFeature] = useDecision('workflow-agent');
  const [inputValue, setInputValue] = useState(searchQuery);

  const debouncedSearchChange = useMemo(() => debounce(onSearchChange, 300), [onSearchChange]);

  // Update input value when searchQuery prop changes (e.g., from URL)
  useEffect(() => {
    setInputValue(searchQuery);
  }, [searchQuery]);

  const handleInputChange = (value: string) => {
    setInputValue(value);
    debouncedSearchChange(value);
  };

  return (
    <Flex className={styles.searchContainer}>
      <Flex flexDirection="row">
        <SearchInput
          placeholder="Search agents"
          value={inputValue}
          onChange={e => handleInputChange(e.target.value)}
          className={styles.searchInput}
        />
        {workflowAgentFeature.enabled && (
          <AgentFilters
            agentType={agentType}
            status={status}
            onAgentTypeChange={onAgentTypeChange}
            onStatusChange={onStatusChange}
          />
        )}
      </Flex>

      <AgentAddDropdown />
    </Flex>
  );
}
